export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 py-20 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="text-xs md:text-sm font-medium text-gray-700 bg-white border border-gray-200 px-4 py-2 rounded-full whitespace-nowrap">
                BtoB / サイト改善 × 広告運用
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight">
              「問い合わせが来ない」を、<br />
              <span className="text-gray-700">"問い合わせが来る構造"</span>に変える
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed">
              広告を回す前に、LPと導線を最適化。<br />
              少額広告で検証し、数字で改善を積み上げます。
            </p>

            <ul className="space-y-3">
              {[
                '何が原因か"10分で"特定（無料）',
                '改修ポイントを優先順位つきで提示',
                '広告は無駄撃ちせず「症状キーワード」中心で検証'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-gray-900 text-xl"></i>
                  </div>
                  <span className="text-sm md:text-base text-gray-700">{item}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap items-center gap-3 pt-4">
              {['改善設計', '計測/分析', '広告運用', 'クリエイティブ'].map((label, index) => (
                <span key={index} className="text-xs font-medium text-gray-600 bg-gray-100 px-3 py-1.5 rounded-full whitespace-nowrap">
                  {label}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={() => scrollToSection('cta')}
                className="bg-gray-900 text-white px-8 py-4 rounded-lg font-bold text-sm md:text-base hover:bg-gray-800 transition-all hover:shadow-lg flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer group"
              >
                無料診断を申し込む（10分）
                <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
              </button>
              <button
                onClick={() => scrollToSection('why')}
                className="bg-white text-gray-900 border-2 border-gray-900 px-8 py-4 rounded-lg font-bold text-sm md:text-base hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                改善の考え方を見る
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/9d5f6ec57b93ee88cc5b903f5478d0bf.jpg"
                alt="サイト改善と広告検証のダッシュボード"
                className="w-full h-auto object-cover"
              />
            </div>
            <p className="text-xs text-gray-500 mt-3 text-center">
              ※ダッシュボード・改善図・作業画面のイメージ
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
